export const PREFILTERED_JOB_SEARCH_CONTENT_QUERY_KEY = "prefilteredJobSearch::content"
